module.exports = __webpack_public_path__ + "assets/img/Logitech-VC-4-Australia-Landing-Page.9d0fa7ea.webp";